import { SelectPicker } from "rsuite";
import { useTranslation } from "react-i18next";
import { Field } from "react-final-form";
import { useMemo } from "react";

const OrderServiceItems = ({
  onServiceItemChange,
  orderServiceItems = [],
  assignedToList = [],
  setStopSubmit,
}: {
  onServiceItemChange?: Function;
  orderServiceItems?: any[];
  assignedToList?: any[];
  setStopSubmit?: Function;
}) => {
  const { t } = useTranslation();

  const updateAssignedTo = (index: number, value: number) => {
    const updatedItems = orderServiceItems.map((item, i) =>
      i === index ? { ...item, item_assigned_to: value } : item,
    );

    onServiceItemChange?.(updatedItems);
  };

  const updateServicePrice = (index: number, value: number) => {
    const updatedItems = orderServiceItems.map((item, i) =>
      i === index ? { ...item, item_service_price: value } : item,
    );

    onServiceItemChange?.(updatedItems);
  };

  const totalServicePrice = useMemo(() => {
    return orderServiceItems.reduce((sum, item) => {
      const price = Number(item.item_service_price) || 0;
      return sum + price;
    }, 0);
  }, [orderServiceItems]);

  return (
    <div>
      <div className="address-bx">
        <h5>
          {t("SERVICE")} {t("ITEMS")}{" "}
          <span style={{ fontWeight: "normal", marginLeft: 6 }}>
            ({t("TOTAL")}: {totalServicePrice.toFixed(2)})
          </span>
        </h5>
      </div>

      {orderServiceItems?.map((sitem: any, index: number) => {
        const fieldSuffix = `${sitem.product_id}_${sitem.qty_no}_${index}`;

        return (
          <div className="flex-container row-field" key={fieldSuffix}>
            <Field name={`item_price_${fieldSuffix}`}>
              {() => (
                <div className="flex-item">
                  <label>
                    {sitem.item_name} {sitem.qty_no}
                  </label>
                  <input
                    type="number"
                    min={0}
                    value={sitem.item_service_price}
                    step="any"
                    onChange={(e) =>
                      updateServicePrice(index, Number(e.target.value))
                    }
                  />
                </div>
              )}
            </Field>

            <div className="flex-item">
              <label>
                {t("ASSIGNED")} {t("TO")}
              </label>
              <SelectPicker
                data={assignedToList}
                valueKey="id"
                labelKey="name"
                value={sitem.item_assigned_to}
                onChange={(value) => updateAssignedTo(index, value)}
                cleanable
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderServiceItems;
